import { Therapist } from 'types/types';
import { INSIDERS, INSIDERS_SET } from 'appConstants';

interface Params {
  therapist: Therapist;
}

export const isTherapistAnInsider = ({ therapist }: Params): boolean =>
  INSIDERS_SET.has(String(therapist.clId) as (typeof INSIDERS)[number]);
